import Breadcrumbs from './Breadcrumbs';

export { type BreadcrumbsProps } from './Breadcrumbs';
export default Breadcrumbs;
